export default __webpack_public_path__ + "static/media/bookmark-outline.1b77755e.svg";